/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Candidate_Profile_Experience_PlaceholderInputs */

const en_candidate_profile_experience_placeholder = /** @type {(inputs: Candidate_Profile_Experience_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe your relevant work experience...`)
};

const de_candidate_profile_experience_placeholder = /** @type {(inputs: Candidate_Profile_Experience_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschreiben Sie Ihre relevante Arbeitserfahrung...`)
};

/**
* | output |
* | --- |
* | "Describe your relevant work experience..." |
*
* @param {Candidate_Profile_Experience_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const candidate_profile_experience_placeholder = /** @type {((inputs?: Candidate_Profile_Experience_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Candidate_Profile_Experience_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_candidate_profile_experience_placeholder(inputs)
	return en_candidate_profile_experience_placeholder(inputs)
});